import { Button, Col, Colors, IcScreen, IcTrash, Text } from 'basic-ui-lib';
import MainZone from 'basic-ui-lib/components/screen/MainZone';
import MainZoneTicket from 'basic-ui-lib/components/screen/MainZoneTicket';
import Portrait from 'basic-ui-lib/components/screen/Portrait';
import ThreePortraits from 'basic-ui-lib/components/screen/ThreePortraits';
import ThreeZone from 'basic-ui-lib/components/screen/ThreeZone';
import TwoZone from 'basic-ui-lib/components/screen/TwoZone';
import { IChannel } from 'modules/channel/interfaces/api';
import { LayoutCode } from 'modules/channel/services/constants';
import styled from 'styled-components';

interface ChannelItemProps {
  onDelete?: (id: string) => void;
  onSetToScreen?: (id: string) => void;
  channel: IChannel;
}

const layoutMap: Record<string, (props: any) => React.ReactNode> = {
  [LayoutCode.MAIN_ONLY]: (props) => <MainZone border={4} {...props} />,
  [LayoutCode.MAIN_TICKER_BOTTOM]: (props) => <MainZoneTicket border={4} gap={4} {...props} />,
  [LayoutCode.LEFT_RIGHT]: (props) => <TwoZone border={4} gap={4} {...props} />,
  [LayoutCode.MAIN_RIGHT_BOTTOM]: (props) => <ThreeZone border={4} gap={4} {...props} />,
  [LayoutCode.THREE_PORTRAITS]: (props) => <ThreePortraits border={4} gap={4} {...props} />,
  [LayoutCode.MAIN_PORTRAIT]: (props) => <Portrait border={4} {...props} />,
};

const ChannelItem = ({ channel, onDelete, onSetToScreen }: ChannelItemProps) => {
  const { name, layoutCode, contentItems, id } = channel;
  return (
    <Container>
      <Content>
        {layoutMap?.[layoutCode]?.({
          value: contentItems,
        })}
        <Col width='100%' gap={0}>
          <Title>
            <Text ellipsis lineClamp={1} color='primary.6' content_2>
              {name}
            </Text>
          </Title>
          <Text color='neutral.text.3' content_3 left>
            iPadOS/iOS 2436 x 1125
          </Text>
        </Col>
      </Content>
      <ActionBottom>
        <Button onClick={() => onDelete && onDelete(id)} type_cancel lg className='styled-button'>
          <IcTrash width={20} height={20} />
        </Button>
        <Button
          prefix={<IcScreen fill={Colors.neutral.bg[1]} />}
          onClick={() => onSetToScreen && onSetToScreen(id)}
          type_second
          lg
          className='styled-button-screen'
        >
          Set to Screen
        </Button>
      </ActionBottom>
    </Container>
  );
};

export default ChannelItem;

const Container = styled.div`
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  align-items: flex-start;
  height: 315px;
  background: ${Colors.neutral.bg[1]};
  box-shadow: 0px 8.38px 16.76px 0px #00000026;
  border-radius: 16px;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  padding: 0 16px 16px 16px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`;

const Title = styled.div`
  width: 100%;
  display: flex;
  padding: 16px 0 8px 0;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const ActionBottom = styled.div`
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 0 0 16px 16px;
  background: #ffffff;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.1);

  .styled-button {
    padding: 0 14px;
  }
  .styled-button-screen {
    flex: 1;
    padding: 0 12px;
  }
`;
